import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import nobracLogo from '../../assets/nobrac.jpg';

const Header = ({ toggleSidebar, isSidebarOpen, showSidebar, isMobile }) => {
  const { user, role, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header style={styles.header}>
      <div style={styles.headerContent}>
        {showSidebar && isMobile && (
          <button
            onClick={toggleSidebar}
            style={styles.menuToggle}
            aria-label={isSidebarOpen ? "Close menu" : "Open menu"}
          >
            {isSidebarOpen ? '✕' : '☰'}
          </button>
        )}

        <div style={{
          ...styles.logo,
          marginLeft: showSidebar && isMobile ? '10px' : '0',
        }}>
          <Link to="/" style={styles.logoLink}>
            <div style={styles.logoContainer}>
              <img
                src={nobracLogo}
                alt="NOBRAC Logo"
                style={{
                  ...styles.logoImage,
                  height: isMobile ? '32px' : '40px',
                }}
              />
            </div>
          </Link>
        </div>

        {isAuthenticated && (
          <div style={styles.userInfo}>
            <div style={{
              ...styles.userProfile,
              padding: isMobile ? '0.25rem' : '0.25rem 0.25rem 0.25rem 0.5rem',
            }}>
              <div style={styles.userAvatar}>
                {user?.name?.charAt(0) || 'U'}
              </div>
              {!isMobile && (
                <div style={styles.userDetails}>
                  <div style={styles.userName}>{user?.name || 'User'}</div>
                  <div style={styles.userRole}>{role}</div>
                </div>
              )}
              <button
                onClick={handleLogout}
                style={styles.logoutButton}
                title="Logout"
              >
                <span style={styles.logoutIcon}>⏻</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: 'var(--primary-dark)',
    color: 'white',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    height: 'var(--header-height)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    backgroundImage: 'linear-gradient(to right, var(--primary-dark), var(--primary-color))',
  },
  menuToggle: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '1.5rem',
    cursor: 'pointer',
    padding: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.5rem',
    width: '44px',
    height: '44px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  headerContent: {
    maxWidth: '1400px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    padding: '0 0.75rem',
    transition: 'padding 0.3s ease',
    width: '100%',

    '@media (min-width: 768px)': {
      padding: '0 2rem',
    },
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logoImage: {
    height: '40px',
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  logoLink: {
    color: 'white',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem',
  },
  navLink: {
    color: 'rgba(255, 255, 255, 0.85)',
    textDecoration: 'none',
    fontSize: '0.9rem',
    padding: '0.5rem 0.75rem',
    borderRadius: '4px',
    transition: 'all 0.2s',
    marginRight: '0.5rem',
  },
  navDivider: {
    width: '1px',
    height: '24px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    margin: '0 0.5rem',
  },
  userProfile: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    padding: '0.25rem 0.25rem 0.25rem 0.5rem',
    borderRadius: '24px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  userAvatar: {
    width: '32px',
    height: '32px',
    backgroundColor: 'var(--secondary-color)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginRight: '0.75rem',
    color: 'white',
    textTransform: 'uppercase',
  },
  userDetails: {
    marginRight: '0.75rem',
  },
  userName: {
    fontWeight: '600',
    fontSize: '0.9rem',
    lineHeight: '1.2',
  },
  userRole: {
    fontSize: '0.75rem',
    opacity: 0.8,
    textTransform: 'capitalize',
  },
  logoutButton: {
    width: '32px',
    height: '32px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.2s',
    padding: 0,
  },
  logoutIcon: {
    fontSize: '1rem',
  },
};

export default Header;
